import { cn } from '@llura/ui';

interface SuggestionChipsProps {
  suggestions: readonly string[];
  /** Currently picked chip — null when the user types a custom word instead. */
  selected: string | null;
  onSelect: (word: string) => void;
}

/**
 * Three-chip selector for safe-word suggestions. Used on Intro screen 4
 * above the custom-word input. Selection is mutually exclusive with the
 * input — the parent owns both pieces of state.
 */
export function SuggestionChips({ suggestions, selected, onSelect }: SuggestionChipsProps) {
  return (
    <div className="flex flex-wrap justify-center gap-2">
      {suggestions.map((word) => {
        const active = selected === word;
        return (
          <button
            key={word}
            type="button"
            onClick={() => onSelect(word)}
            className={cn(
              'rounded-full border px-4 py-2 text-sm transition-all',
              active
                ? 'border-emerald-400 bg-emerald-400/15 text-foreground shadow-[0_0_24px_rgba(52,211,153,0.25)]'
                : 'border-border bg-card/60 text-muted-foreground hover:border-emerald-400/40 hover:text-foreground',
            )}
          >
            „{word}"
          </button>
        );
      })}
    </div>
  );
}
